function ActiveRecord(type, item) {
  this._type=type;
  for(var field in item || {})
    this[field]=item[field];
}
ActiveRecord.prototype.parseFields=function(showFields) {
  var showFieldsLen=showFields.length;
  var tokens=[];
  var lastTokenType=null;
  for(var i=0;i<showFieldsLen;i++) {
    var char=showFields[i];
    var charCode=showFields.charCodeAt(i);
    var incl=(charCode>=65 && charCode<=90) ||
              (charCode>=97 && charCode<=122) ||
              ["_", "-","*","{","}",","].indexOf(char)!=-1;
    if (!incl)
      continue;
    if (lastTokenType!="identifier") {
      tokens.push(char);
      lastTokenType="other";
      if ((charCode>=65 && charCode<=90) ||
          (charCode>=97 && charCode<=122) ||
          ["_", "-","*"].indexOf(char)!=-1)
        lastTokenType="identifier";
    } else if (lastTokenType=="identifier") {
      if ((charCode>=65 && charCode<=90) ||
          (charCode>=97 && charCode<=122) ||
          ["_", "-","*"].indexOf(char)!=-1)
        tokens[tokens.length-1]+=char;
      else {
        tokens.push(char);
        lastTokenType="other";
      }
    }
  }
  while(tokens.length>1) {
    var lastCount=tokens.length;
    var lastOpen=null;
    for(var i in tokens) {
      var token=tokens[i];
      if (Array.isArray(token))
        continue;
      if (token=="{")
        lastOpen=i;
      if (token=="}") {
        if (lastOpen===null)
          return null;
        var inner=tokens.slice(lastOpen*1+1, i*1).filter(item=>item!=",");
        var newInner=[];
        for(var innerItem of inner) {
          if (typeof(innerItem)=="string")
            newInner.push({field: innerItem});
          else if (newInner.length)
            newInner[newInner.length-1].sub=innerItem;
        }
        tokens.splice(lastOpen*1, i-lastOpen+1, newInner);
        break;
      }
    }
    if (tokens.length>=lastCount)
      break;
  }
  return tokens[0] || null;
}
ActiveRecord.prototype.filterFields=function (data, fields) {
  var result={};
  if (typeof(fields)=="string")
    fields=this.parseFields(fields);
  if (!fields)
    return data;
  for(var field in data) {
    var value=data[field];
    if (field=="id" || field=="uuid") {
      result[field]=value;
      continue;
    }
    var fieldDesc=fields.find(item=>item.field==field);
    if (!fieldDesc)
      continue;
    if (typeof(value)!="object" || !fieldDesc.sub)
      result[field]=value;
    else if (Array.isArray(value)) {
      result[field]=value.map(item=>this.filterFields(item, fieldDesc.sub));
    } else {
      result[field]=this.filterFields(value, fieldDesc.sub);
    }
  }
  return result;
}
ActiveRecord.prototype.save=async function(fields) {
  var result=await this.saveNoUpdate(fields);
  if (result.item) {
    for(var field in result.item)
      this[field]=result.item[field];
  }
}
ActiveRecord.prototype.saveNoUpdate=async function(fields) {
  var blacklist=["_type", "id", "uuid"];
  var data={};
  for(var i in this) {
    if (blacklist.indexOf(i)==-1)
      data[i]=this[i];
  }
  if (fields)
    data=this.filterFields(data, fields);
  if (this.id) {
    var result=await api.doUpdate(this._type, this.id, data, true);
    return result;
  } else {
    var result=await api.doCreate(this._type, data, true);
    if (result.item) {
      this.uuid=result.item.uuid;
      this.id=result.item.id;
    }
    return result;
  }
}
ActiveRecord.prototype.action=async function(action, payload) {
  var result=await api.action(this._type, this.id, action, payload, true);
    if (result.item) {
      for(var field in result.item)
        this[field]=result.item[field];
    }
  return result;
}
ActiveRecord.prototype.delete=async function() {
  if (this.id)
    return await api.doDelete(this._type, this.id);
}
ActiveRecord.prototype.upload=async function(file, field) {
  return await api.upload(this._type+"/"+this.id, file, field);
}

var api={
  stores: null,
  objQuery(data, path) {
    var result=[];
    path=path || [];
    for(var key in data) {
      var value=data[key];
      if (Array.isArray(value)) {
        result=[...result, ...this.objQuery(value, [...path, key])];
      } else if (typeof(value)=="object") {
        result=[...result, ...this.objQuery(value, [...path, key])];
      } else {
        var actualKey=[...path, key].map((el,index)=>index?'['+el+']':el).join("");
        result.push([actualKey, value]);
      }
    }
    return result;
  },
  async request(method, path, data) {
    if (method=="GET" && data) {
      path+="?"+(new URLSearchParams(this.objQuery(data)).toString());
    }
    try {
      var loginToken={};
      var authStore=localStorage.getItem('efToken', null);
      if (authStore) {
        loginToken['Authorization']="Bearer "+authStore;
      }
      var req=await fetch(appEnv.apiRoot+path, {
        method,
        headers: {
          ...(method!="GET" && method!="DELETE"?{"Content-Type": "application/json"}:{}),
          ...loginToken,
        },
        cache: 'no-cache',
        ...(method!="GET" && method!="DELETE"?{body: JSON.stringify(data)}:{}),
      });
      try {
        var body=await req.text();
        if (req.ok)
          return JSON.parse(body);
        else
          return {...JSON.parse(body), status: req.status};
      } catch(e) {
        return {status: req.status, error: body};
      }
    } catch(e) {
      return {error: 'network'};
    }
  },
  async upload(path, file, field) {
    try {
      var formData=new FormData();
      formData.append("file", file);
      if (field)
        formData.append("field", field);
      var req=await fetch(appEnv.apiRoot+path, {
        method: "POST",
//         headers: {
//           "Content-Type": "multipart/form-data",
//         },
        cache: 'no-cache',
        body: formData,
      });
      try {
        var body=await req.text();
        if (req.ok)
          return JSON.parse(body);
        else
          return {...JSON.parse(body), status: req.status};
      } catch(e) {
        return {status: req.status, error: body};
      }
    } catch(e) {
      console.log(e);
      return {error: 'network'};
    }
  },
  async list(entity, where, fields, sort, limit, start, getCount, localizations) {
    var args={};
    if (where)
      args.q=where;
    if (fields)
      args.g=fields;
    if (sort)
      args.o=sort.join(",");
    if (limit)
      args.l=limit;
    if (start)
      args.s=start;
    if (localizations)
      args.loc=localizations
    var result=(await this.request("GET", entity, args));
    if (getCount)
      return {count: result.count, items: (result.items || []).map(
      (item)=>new ActiveRecord(entity, item))};
    return (result.items || []).map(
      (item)=>new ActiveRecord(entity, item));
  },
  async get(entity, id, fields) {
    var extra=fields?"?g="+encodeURIComponent(fields):"";
    var item=(await this.request("GET", entity+"/"+id+extra)).item;
    if (item)
      return new ActiveRecord(entity, item);
    return null;
  },
  create(entity) {
    return new ActiveRecord(entity);
  },
  async doDelete(entity, id) {
    return await this.request("DELETE", entity+"/"+id);
  },
  async doUpdate(entity, id, data, returnItem, localizations) {
    var locVal="";
    if (localizations) {
      for(var localizationType in localizations) {
        if (!localizations[localizationType])
          continue;
        locVal+=locVal?"&":"?";
        locVal+="loc["+localizationType+"]="+localizations[localizationType];
      }
    }
    return await this.request("PUT", entity+"/"+id+locVal, {
      item: data,
      ...(returnItem?{"return": true}:{}),
    });
  },
  async doCreate(entity, data, returnItem) {
    return await this.request("POST", entity, {item: data, ...(returnItem?{"return": true}:{})});
  },
  async action(entity, id, name, data, returnItem) {
    return await this.request("PUT", entity+"/"+id+"/"+name, {payload: data, ...(returnItem?{"return": true}:{})});
  },
  async doLogin(username, authdata) {
    return await this.request("POST", "login", {group: "admin", username, ...authdata});
  },
  async root() {
    return await this.request("GET", "");
  },

  nullUuid: "00000000-0000-0000-0000-000000000000",
}

export default api;
